import React, { Component } from "react";
import { Link } from "react-router";
import Nav from '../components/Nav';
import { database, auth } from '../firebase';
import ms from '../ms';

class Bildirimler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ntfs: [],
      okunmamışlarCount: 0, // okunmamış bildirim sayısı
      showEmptyText: false, // boş bildirim durumu
    };

    this.okundu = this.okundu.bind(this);
  }

  componentWillMount() {
    auth.onAuthStateChanged(user => {
      if (user === null) return window.location.pathname = "/giris-yap";

      const previousPosts = this.state.ntfs;
      database.ref(`notifications/${auth.currentUser.uid}`).on('child_added', snap => {
        this.setState(prevState => ({
          showEmptyText: false,
          okunmamışlarCount: snap.val().okundu !== true ? prevState.okunmamışlarCount + 1 : prevState.okunmamışlarCount
        }));

        previousPosts.push({
          key: snap.key,
          author: snap.val().author,
          date: snap.val().date,
          okundu: snap.val().okundu,
          post: snap.val().post,
          type: snap.val().type
        });

        this.setState({
          ntfs: previousPosts,
        });
      });

      database.ref(`notifications/${auth.currentUser.uid}`).on('child_removed', snap => {
        const updatedPosts = previousPosts.filter(post => post.key !== snap.key);
        this.setState({ ntfs: updatedPosts });
      });

      database.ref(`notifications/${auth.currentUser.uid}`).get().then(snap => {
        if (!snap.exists()) {
          this.setState({ showEmptyText: true });
        }
      })
    });
  }

  updateName(id) {
    var data = "";
    database.ref(`users/${id}`).on('value', (snapshot) => {
      data = snapshot.val()?.userName;
    });
    return data;
  }

  updateImage(id) {
    var data = "";
    database.ref(`users/${id}`).on('value', (snapshot) => {
      data = snapshot.val()?.userImage;
    });
    return data;
  }

  updatePostImage(id) {
    var data = "";
    database.ref(`posts/${id}`).on('value', (snapshot) => {
      data = snapshot.val().postImage || "/default.jpg";
    });
    return data;
  }

  convert(ntf) {
    var data = "";
    if (ntf.type == "yorum") data = "Bir yazına yorum yaptı";
    else if (ntf.type == "like") data = "Yazını beğendi";
    else if (ntf.type == "yanıt") data = "Yorumuna yanıt verdi";
    return data;
  }

  okundu() {
    database.ref("notifications").child(auth.currentUser.uid).get().then(snapshot => {
      if (snapshot.exists()) {
        snapshot.forEach(s => {
          database.ref(`notifications/${auth.currentUser.uid}/${s.key}`).update({
            okundu: true
          });
          document.getElementById(s.key+"-ntf").style.background = "#fff";
        })

        this.setState({ okunmamışlarCount: 0 });
      }
    })
  }

  render() {
    return (
      <div className="container">
        <Nav activeItem="notification" />
        <div className='main'>
          <h1 className="h1" id="h1">Bildirimler - {this.state.okunmamışlarCount}</h1>
          <h2 className="h2" style={{ display: this.state.showEmptyText ? "block" : "none" }}>Burada bildirimlerini görebilirsin.</h2>
          <div className="okundu-div">
            <button className="okundu" id="okundu" style={{ display: this.state.ntfs.length > 0 ? "block" : "none" }} onClick={this.okundu}>
              Tümünü okundu işaretle
            </button>
          </div>
          {this.state.ntfs.length > 0 ? this.state.ntfs.map((ntf) => {
            return (
              <div className="main-card" key={ntf.key}>
                <div className="main-card-ntf" id={ntf.key+"-ntf"} style={ntf.okundu == true ? {background: "#fff"} : {background: "#3486eb"}}></div>
                <Link to={"/profil/"+ntf.author}><img src={this.updateImage(ntf.author) || "/default_user.jpg"} className="main-card-img" /></Link>
                <div style={{ width: "100%", userSelect: "none" }}>
                  <div className="main-card-başlık">
                    <Link to={"/profil/"+ntf.author}>
                      <div className="main-card-başlık" style={{ margin: "0" }}>
                        {this.updateName(ntf.author)}
                      </div>
                    </Link>
                    <div className="main-card-date">{ms(Date.now() - ntf.date, {long: true}) + ` önce`}</div>
                  </div>
                  <p className="main-card-icerik">{this.convert(ntf)}</p>
                </div>
                <Link to={"/p/"+ntf.post}><img src={this.updatePostImage(ntf.post)} className="main-card-img2" /></Link>
              </div>
            );
          }).reverse() : this.state.showEmptyText ? <></> : <img src="/loading.svg" id="loading-non" className="loading-non" />}
        </div>

        <style>{`
          html {
            background: #F57029;
          }

          .main {
            max-width: 762px;
            width: 100%;
            margin: 0 auto;
            margin-top: 100px;
            padding: 0;
            text-align: center;
          }

          .h1 {
            text-align: center;
            margin-bottom: 50px;
            color: #fff;
          }

          .h2 {
            text-align: center;
            color: #fff;
            opacity: 0.6;
          }

          .okundu-div {
            float: right;
            margin-bottom: 10px;
          }

          .okundu {
            cursor: pointer;
            border: none;
            border-radius: 20px;
            background: #2f2d33;
            color: #fff;
            outline: none;
            padding: 10px;
            transition: .1s;
            display: none;
          }

          .okundu:hover {
            background: #5b5b5c;
          }

          .main-card {
            border-radius: 10px;
            margin: 10px 0px;
            padding: 0px;
            background: #ffffff;
            width: 100%;
            max-width: 100%;
            height: auto;
            display: flex;
          }

          .main-card-ntf {
            width: 8px;
            height: 8px;
            margin: 28px 0 0 10px;
            border-radius: 100%;
            background: #77abfc;
          }

          .main-card-img {
            position: relative;
            margin: 10px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            object-fit: cover;
          }

          .main-card-img2 {
            position: relative;
            margin: 10px;
            border-radius: 5px;
            width: 60px;
            height: 40px;
            object-fit: cover;
          }

          .main-card-başlık {
            font-size: 13px;
            margin-top: 10px;
            text-align: left;
            color: #290025;
            display: flex;
          }

          .main-card-icerik {
            color: #000;
            height: auto;
            text-align: left;
            font-size: 14px;
            font-weight: normal;
            padding-right: 5px;
            margin-top: 5px;
          }

          .main-card-date {
            text-align: left;
            font-size: 13px;
            color: #606060;
            position: relative;
            padding-left: 10px;
          }

          @media (max-width: 623px) {
            .main {
              width: 100%;
              text-align: center;
              padding-bottom: 52px;
            }

            .h1 {
              width: 100%;
              position: fixed;
              z-index: 1;
              background: #2f2d33;
              height: 50px;
              padding-left: 10px;
              margin: 0;
              line-height: 50px;
              font-size: 20px;
              text-align: left;
              top: 0;
            }

            .main-card {
              border-top: 1px solid #bfbfbf;
              border-radius: 0;
              box-shadow: 0 0;
              margin: 0;
            }

            .okundu-div {
              width: 160px;
              height: 35px;
              margin: 0;
            }

            .okundu {
              display: block;
              border-radius: 10px 0 0 0;
              position: absolute;
              right: 0px;
              transition: .2s;
            }

            .post {
              width: 100%;
              max-width: 70%;
              height: auto;
              margin: 10px auto;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default Bildirimler;
